import { Commit, ActionTree } from 'vuex';
import axiosInstance from '@/services/api/http.service.js';
import getEnv from '@/utils/env';
import { State } from '@/store/modules/alertV2/configure/configure.store';
const API_URL =
  getEnv('VUE_APP_ALERT_HOST') ||
  process.env.VUE_APP_ALERT_HOST ||
  'http://localhost:63250';

const http = new axiosInstance({ auth: true });

const actions: ActionTree<State, any> = {
  async getGeneratedAlerts(
    context: { commit: Commit },
    params: {
      keyword: String;
      serviceId: String;
      limit: Number;
      from: Number;
      sortBy: String;
      order: String;
    }
  ) {
    try {
      if (params.serviceId === '') {
        return;
      }
      const response = await http.post(
        `${API_URL}/api/v1/incidents/generated`,
        params
      );
      if (response && response.data && response.data.success == true) {
        return response.data.data;
      }
      throw response;
    } catch (error) {
      // Handle error
    }
  },
  async closeAlerts(
    context: { commit: Commit },
    params: {
      incidentId: String;
      lastUpdatedBy: String;
    }
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      try {
        if (params.incidentId === '') {
          return;
        }
        const response = http.post(
          `${API_URL}/api/v1/incidents/close`,
          params
        );
        if (response && response.data && response.data.success == true) {
          return response.data.data;
        }
        resolve(response);
      } catch (error) {
        reject(error);
        // Handle error
      }
    })
  },
};

export default actions;
